import $ from 'jquery';

$( document ).on( 'click', '.js-vertical-tab-link', function( e ) {
	e.preventDefault();
	const tabTitle = $( this ).data( 'tab' );
	const $tab = $( '.js-vertical-tab[data-tab="' + tabTitle + '"]' );

	$( '.js-vertical-tab-link' ).removeClass( 'c-side-nav__link--current' );
	$( '.js-vertical-tab' ).hide();
	$( this ).addClass( 'c-side-nav__link--current' );
	$tab.show();
} );
